import { render, staticRenderFns } from "./MyFavoritesToggle.vue?vue&type=template&id=4aa5816b&"
import script from "./MyFavoritesToggle.vue?vue&type=script&lang=js&"
export * from "./MyFavoritesToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports